import billStyles from "./Bill.styles";
import BasicCard from "../../../../components/card/basiccard/BasicCard";
import Heading from "../../../../components/heading/Heading";
import TextInput from "../../../../components/input/textinput/TextInput";
import PasswordInput from "../../../../components/input/passwordinput/PasswordInput";
import Button from "../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import { getBillOrgDetailsByUser, getFormAndTaxYearList, getFormSetting, getLoadImportData, getOrganization } from "./BillSaga";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loadable from "../../../../components/loadable/Loadable";
import { BILL_LOADING_STATES, BILL_LOADING_STATES_MESSAGE_MAP, FORM_IDS, INTEGRATION_CONSTANTS } from "../constants";
import { componentKey } from "./BillSlice";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import RichGrid from "../../../../components/richgrid/RichGrid";
import ImportDataGridView from "../../../components/importdatagridview/ImportDataGridView";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import Checkbox from "../../../../components/checkbox/basecheckbox/Checkbox";

export default function Bill() {

    useGarbageCollector(componentKey);
    const { organizationDetails, formAndTaxYearList, importData, isImportDataGridViewLoaded, formSettings } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();

    const [emailId, setEmailId] = useState("");
    const [password, setPassword] = useState("");
    const { loadingState } = useSelector(state => state[componentKey]);
    const [taxYearMap, setTaxYearMap] = useState({});
    const [taxYearOptions, setTaxYearOptions] = useState([]);
    const [selectedFormMap, setSelectedFormMap] = useState({});
    const [formattedTenantList, setFormattedTenantList] = useState([]);
    const [formOptions, setFormOptions] = useState([]);
    const [selectedTaxYear, setSelectedTaxYear] = useState({});
    const [selectedForm, setSelectedForm] = useState({});
    const [selectedFilterOptionsMap, setSelectedFilterOptionsMap] = useState({});

    const handleDataLoad = (orgId, orgName) => {
        if (orgId && taxYearMap[orgId] && selectedFormMap[orgId]) {
            dispatch(getLoadImportData({
                integrationImportRequestDto: {
                    TaxYear: taxYearMap[orgId],
                    FormName: selectedFormMap[orgId],
                    BusinessId: orgId,
                    Source: 'BILL',
                    BusinessName: orgName,
                    FiltersOn: selectedFilterOptionsMap[orgId] ?? false
                }
            }));
            setSelectedForm(selectedFormMap[orgId]);
            setSelectedTaxYear(taxYearMap[orgId]);
        } else {
            dispatch(addNotifications({
                heading: "Required fields missing",
                message: "Please choose tax year and form type to proceed"
            }));
        }
    };

    const handleLoginButtonClick = () => {
        if (emailId && password) {
            const encodedPassword = btoa(password);
            dispatch(getOrganization({
                billModel: {
                    EmailId: emailId,
                    Password: encodedPassword
                }
            }));
        }
        else {
            dispatch(addNotifications({
                heading: "Required field missing",
                message: "Please enter email and password to proceed"
            }));
        }
    };

    const onChangeHandlerEmail = (event, rules) => {
        const { name, value } = event.target;
        setEmailId(value);
    };

    const onChangeHandlerPassword = (event, rules) => {
        const { name, value } = event.target;
        setPassword(value);
    };

    useEffect(() => {
        dispatch(getFormAndTaxYearList());
        dispatch(getBillOrgDetailsByUser());
    }, [])

    useEffect(() => {
        if (formAndTaxYearList) {
            setTaxYearOptions(formAndTaxYearList?.TaxYear);
            setFormOptions(formAndTaxYearList?.FormType);
        }
    }, [formAndTaxYearList]);

    useEffect(() => {
        if (organizationDetails.length > 0) {
            const formattedList = organizationDetails.map(tenant => ({
                TenantName: tenant.orgName,
                TenantId: tenant.orgId
            }));
            setFormattedTenantList(formattedList);
        }
    }, [organizationDetails]);

    useEffect(() => {
        if (importData) {
            dispatch(getFormSetting({ formId: selectedForm, year: selectedTaxYear }));
        }
    }, [importData]);

    const gridColumns = [
        {
            header: 'Organisation Name',
            renderLogic: (row) => (
                <div style={billStyles.gridRecordsMargin}>
                    <span>{row?.TenantName}</span>
                </div>
            )
        },
        {
            header: 'Tax Year',
            renderLogic: (row) => (
                <div style={billStyles.gridRecordsMargin}>
                    <SelectDropdown
                        label=""
                        placeHolder="Select taxYear"
                        name="taxYear"
                        value={{ label: taxYearMap[row?.TenantId] || '', value: taxYearMap[row?.TenantId] || '' }}
                        onSelectCb={(name, selectedOption) => setTaxYearMap(prevState => ({
                            ...prevState,
                            [row.TenantId]: selectedOption.value
                        }))}
                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                        options={taxYearOptions}
                        dropdownMenustyle={billStyles.dropdownWidth}
                        dropdownContainerStyles={billStyles.dropdownWidth}
                    />
                </div>
            )
        },
        {
            header: 'Form Type',
            renderLogic: (row) => (
                <div style={billStyles.gridRecordsMargin}>
                    <SelectDropdown
                        label=""
                        placeHolder="Select Form"
                        name="selectedForm"
                        value={{ label: selectedFormMap[row?.TenantId] || '', value: selectedFormMap[row?.TenantId] || '' }}
                        onSelectCb={(name, selectedOption) => setSelectedFormMap(prevState => ({
                            ...prevState,
                            [row.TenantId]: selectedOption.value
                        }))}
                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                        options={formOptions}
                        dropdownMenustyle={billStyles.dropdownWidth}
                        dropdownContainerStyles={billStyles.dropdownWidth}
                    />
                </div>
            )
        },
        {
            header: 'Filter Option',
            renderLogic: (row) => (
                <div style={billStyles.gridRecordsMargin}>
                    <Checkbox
                        checked={selectedFilterOptionsMap[row?.TenantId]}
                        onChangeCb={(e) => setSelectedFilterOptionsMap(prevState => ({
                            ...prevState,
                            [row?.TenantId]: e.target.checked ? true : false
                        }))}
                    />
                </div>
            )
        },
        {
            header: 'Actions',
            renderLogic: (row) => (
                <div style={billStyles.gridRecordsMargin}>
                    <Button
                        type={BUTTON_TYPE.PRIMARY}
                        title="DataLoad"
                        onClickCb={() => handleDataLoad(row?.TenantId, row?.TenantName)}
                    >
                        Load Data
                    </Button>
                </div>
            )
        }
    ];

    return (
        <>
            {(formSettings && selectedTaxYear && selectedForm && isImportDataGridViewLoaded) ? (
                <ImportDataGridView
                    isStateFilingApplicable={false}
                    filingForCorrected={false}
                    formSettings={formSettings}
                    formName={selectedForm}
                    formId={
                        (() => {
                            switch (selectedForm) {
                                case INTEGRATION_CONSTANTS.NEC_FORM:
                                    return FORM_IDS.$1099NEC;
                                case INTEGRATION_CONSTANTS.MISC_FORM:
                                    return FORM_IDS.$1099MISC;
                                default:
                                    return null;
                            }
                        })()
                    }
                    taxYear={selectedTaxYear}
                />
            )
                : (
                    <>
                        {
                            organizationDetails.length > 0 ?
                                (
                                    <>
                                        <Loadable
                                            currentState={loadingState.state}
                                            loadingStates={[BILL_LOADING_STATES.PAGE_LOADING]}
                                            messageMap={BILL_LOADING_STATES_MESSAGE_MAP}
                                            isNewLoadable={true}
                                        >
                                            <RichGrid
                                                columns={gridColumns}
                                                data={formattedTenantList}
                                            />

                                        </Loadable>
                                    </>
                                ) :
                                (<div style={billStyles.container}>
                                    <div style={billStyles.cardContainer}>
                                        <Loadable
                                            currentState={loadingState.state}
                                            loadingStates={[BILL_LOADING_STATES.PAGE_LOADING]}
                                            messageMap={BILL_LOADING_STATES_MESSAGE_MAP}
                                            isNewLoadable={true}
                                        >
                                            <BasicCard fullWidth={true} customStyles={billStyles.cardCustomStyles}>
                                                <Heading type="h2" customStyle={{ ...billStyles.cardHeading }}>
                                                    Bill Login Credentials
                                                </Heading>
                                                <div style={billStyles.fieldContainer}>
                                                    <TextInput
                                                        name="EmailId"
                                                        label="Email"
                                                        placeHolder='Email'
                                                        value={emailId}
                                                        onChangeCb={onChangeHandlerEmail}
                                                    />
                                                </div>
                                                <div style={billStyles.fieldContainer}>
                                                    <PasswordInput
                                                        name="Password"
                                                        type="password"
                                                        placeHolder='Password'
                                                        value={password}
                                                        onChangeCb={onChangeHandlerPassword}
                                                    />
                                                </div>
                                                <div>
                                                    <Button
                                                        type={BUTTON_TYPE.PRIMARY}
                                                        style={billStyles.buttonContainer}
                                                        onClickCb={handleLoginButtonClick}
                                                    >
                                                        Login
                                                    </Button>
                                                </div>
                                            </BasicCard>
                                        </Loadable>
                                    </div>
                                </div>
                                )
                        }
                    </>)}
        </>
    );
}